import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PETITION_QUALITY_SCORE_TOGGLE = defineFcm('starfish_petition_quality_score_toggle')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
